import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/core/data.service';
import { Driver } from './../../shared/driver.model';
import { SelectService } from 'src/app/core/select.service';

@Component({
    selector: 'app-search-view',
    templateUrl: './search-view.component.html',
    styleUrls: ['./search-view.component.css']
})
export class SearchViewComponent implements OnInit {
    /// data properties
    driver: Driver;
    drivers: Driver[] = [];
    errorMessage: string;
    // selected properties
    selectedDriverId: Driver;
    // logic properties
    isSelected = false;

    constructor(
        private dataService: DataService,
        private selectService: SelectService) { }

    ngOnInit() {
        this.isSelected = false;
        // data methods
        this.refreshDrivers();
        this.selectService.selectedDriverId$.subscribe(
            id => this.selectedDriverId = id
        );
        this.selectService.isSelected$.subscribe(
            selected => this.isSelected = selected
        );
    }

    refreshDrivers() {
        this.dataService.updateDrivers().subscribe(
            drivers => this.drivers = drivers
        );
    }

    trackByFn(driver: Driver) {
        return driver.shipment_id;
    }
}
